import { createContext } from 'react';

// Work's event transcript contains live replies before conversation storage.
// Carry the decision for that exact rendered row, using its actual parent turn.
export const InteractiveAnswerContext = createContext(null);
